import { type FC } from "react";
import {
  InstructorDetail,
  InstructorEducationalBackground,
} from "@features/instructor/types";
import type { HTMLReactParserOptions } from "html-react-parser";
import { NewExploreProduct } from "types/api/new-explore";
import dynamic from "next/dynamic";
import useMobileInstructorHeader from "../hooks/useMobileInstructorHeader";

const MobileHeader = dynamic(() => import("./MobileHeader"), { ssr: false });

interface Props {
  instructor: InstructorDetail;
  options: HTMLReactParserOptions;
  productCount: number;
  products: NewExploreProduct[] | undefined;
  degrees: InstructorEducationalBackground[];
}

const MobileInstructor: FC<Props> = ({
  instructor,
  options,
  productCount,
  products,
  degrees,
}) => {
  const { isAdmin, handleClickTab, tabs, refs, scrollOffset, activeId } =
    useMobileInstructorHeader({
      instructor,
      options,
      productCount,
      products,
      degrees,
    });
  return (
    <>
      <MobileHeader
        isAdmin={isAdmin}
        handleClickTab={handleClickTab}
        currentTabInstructorItem={tabs}
        activeId={activeId}
      />

      {tabs.map((tab, index) => (
        <div
          key={tab.id}
          ref={(el) => {
            refs.current[index] = {
              e: el,
              offset: scrollOffset,
            };
          }}
          id={tab.id}
        >
          {tab.node}
        </div>
      ))}
    </>
  );
};

export default MobileInstructor;
